export default __webpack_public_path__ + "static/SRUS RT175 - Product Specifications & Technical Data-4c06ac04169fd14c4d11b28c23918d0b.pdf";